<template>
    <div>
      <!-- page-wrapper Start-->
      <div class="container-fluid p-0">
        <div class="row m-0">
          <div class="col-12 p-0">
            <div class="login-card">
              <div>
                <div>
                  <a class="logo">
                    <img :src="ImageEndpoint + CompanyLogo" class="img-fluid for-light" v-if="CompanyLogo" style='height: 50px;'>
                        <img src="@/assets/images/logo.png" class="img-fluid for-light" v-if="!CompanyLogo" style='height: 50px;'>
                   <!--- <img
                      src="@/assets/images/logo.png"
                      class="img-fluid for-light"
                      style="height: 50px"
                    />-->
                  </a>
                </div>
                <div class="login-main text-center">
                  <b-card no-body>
                    <b-tabs pills vertical>
                      <b-tab active>
                        <b-card-text>
                          <template v-if="!userAlreadySync">
                            <p>Set up your two factor authentication by scanning the barcode below using <strong>Google Authenticator APP</strong>. Alternatively, you can use the code <strong>{{ secret }}</strong></p>
                            <img :src="getGroupQRCode()" style="max-height: 300px" />
                            <p>Take note of the <strong>OTP</strong> generated on your <strong>Google Authenticator APP</strong> and enter below. You will be unable to login otherwise. </p>
                          </template>
                          <template v-else>
                            <p>Please enter the  <strong>OTP</strong> generated on your <strong>Google Authenticator App</strong>. Ensure you submit the current one because it refreshes every 30 seconds.</p>
                          </template>
                            <div data-v-5f6fef9c="" class="col-xl-12 m-t-20">
                                <div class="row">
                                <div class="col-xl-9 p-0">
                                    <div class="d-flex w-250 me-3 mb-2 label-box">
                                        <input type="tel" pattern="\d*" maxlength="6" v-model="otp" placeholder="Enter OTP" class="form-control"  
                                        :class="{
                                            'is-invalid': submitted && $v.otp.$error,
                                          }">
                                    </div>
                                </div>
                                <div  class="col-xl-3"><button style="padding: 9px 20px;"  type="button" @click="verifyOTP" class="button btn btn-xs btn-primary p-10">Verify</button> <i class="fa fa-spinner fa-spin"  v-if="ShowVerifyLoader" style="font-size: 32px;"></i></div>
                                  <div
                                    v-if="submitted && !$v.otp.required"
                                    class="invalid-input text-danger"
                                  >
                                    OTP is required
                                  </div> 
                                  <div v-if="submitted && !$v.otp.minLength" class="invalid-input text-danger">Please enter valid OTP.</div> 
                                </div>
                                </div>
                            </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </div>
                <div class="col-sm-12 text-center" v-if="CompanyLogo">
                  <p class="m-b-5">Powered by</p>
                  <img
                    src="@/assets/images/logo.png"
                    class="img-fluid for-light1"
                    style="width: 100px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- latest jquery-->
    </div>
  </template>

<script>
import Axios from "axios";
import Endpoints from "@/config/ApiEndpoints.js";
import { required, minLength } from "vuelidate/lib/validators";
import Userauth from "../auth/js/index";

export default {
  components: {},
  data() {
    return {
        ImageEndpoint: Endpoints.Helper.Image + "/",
        CompanyLogo: "",
        ShowLoader: false,
        ShowVerifyLoader: false,
        QrcodeURL:"",
        userAlreadySync:true,
        secret:"",
        otp:"",
        submitted: false,
        QRCodeEndpoint: Endpoints.QR.Generate + "?content=",
    };
  },
  validations: {
    otp: { required, minLength: minLength(6) }
  },
  mounted() {
    var Company = JSON.parse(localStorage.getItem("Company"));
      if (Company && Company.logo) {
        this.CompanyLogo = Company.logo;
      }
    setTimeout(() => {
      this.GetGoogleQrCode();
    }, 1000);
  },
  methods: {
    verifyOTP(){
      this.submitted = true;
      this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
      this.ShowVerifyLoader = true;
      Axios.post(Endpoints.User.Google2faBarcodeVerify, {
        token: localStorage.getItem("token"),
        email: localStorage.getItem("email2fa"),
        secret:this.secret,
        otp:this.otp,
      }).then((Response) => {
        this.ShowVerifyLoader = false;
        if (Response?.data?.success) {
          localStorage.setItem("token", Response.data.token);
          localStorage.setItem(
            "User",
            JSON.stringify(Response.data.User)
          );
          localStorage.setItem(
              "PasswordReset",
              Response.data.User['is_password_reset']
            );
          localStorage.setItem(
            "Company",
            JSON.stringify(Response.data.Company)
          );
          localStorage.setItem(
            "FleetSubscription",
            JSON.stringify(Response.data.FleetSubscription)
          );

          // Update the value
          localStorage.setItem(
            "AccountPermissions",
            JSON.stringify(Response.data.AccountPermissions)
          );
          // Update the value
          localStorage.setItem(
            "permissions",
            JSON.stringify(Response.data.permissions)
          );
          window.pbx_SiteTitle = Response.data.Company.name;
          Userauth.localLogin(Response.data);
          localStorage.removeItem("email2fa");
          this.$router.replace("/");
        }else{
          this.$swal.fire({
            title: "Oops!",
            text: Response?.data?.message || "Something went wrong",
            icon: "error",
            confirmButtonText: "Close",
          });
        }
      });
    },
    GetGoogleQrCode() {
      if(localStorage.getItem("email2fa") && localStorage.getItem("email2fa") != ""){
        this.ShowLoader = true;
        Axios.post(Endpoints.User.Google2faBarcodeURL, {
          email: localStorage.getItem("email2fa"),
        }).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.QrcodeURL = Response.data.qrCodeUrl;
            this.secret = Response.data.secret;
            this.userAlreadySync = Response.data.userAlreadySync;
          }
        });
      }else{
        this.$router.push("/auth/login");
      }
    },
    getGroupQRCode() {
      var qrurl = this.QRCodeEndpoint + btoa(this.QrcodeURL);
      return qrurl;
    },
  },
};
</script>
<style scoped>
.qr-code-text {
  font-size: 14px;
  font: bold;
}
@media print {
  .print_btn {
    display: none;
  }
}
</style>
